import { useFadeIn } from "@/hooks/useFadeIn";
import { usePageContent } from "@/hooks/usePageContent";

const pillars = [
  {
    index: "01",
    title: "Educate",
    description: "We clarify your options, explain the tradeoffs, and help you make informed decisions with less guesswork.",
  },
  {
    index: "02",
    title: "Empower",
    description: "We give you the strategy, timing, and confidence to act decisively when the right opportunity appears.",
  },
  {
    index: "03",
    title: "Elevate",
    description: "We position your property and your investment for stronger presentation, better offers, and stronger performance.",
  },
];

const MissionSection = () => {
  const { ref, visible } = useFadeIn();
  const { getContent } = usePageContent({ pageKey: "home" });
  const heading = getContent("mission", "heading", "Why Work With Hadassah Homes");
  const body = getContent(
    "mission",
    "body",
    "Our approach is built around one goal: helping you make clearer decisions and stronger moves.",
  );

  return (
    <section className="bg-[#f6f2e9] py-12 md:py-16">
      <div
        ref={ref}
        className={`mx-auto max-w-wide px-5 md:px-12 transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-body text-[10px] uppercase tracking-[0.26em] text-accent mb-4">
            Our Approach
          </p>
          <h2 className="font-headline text-4xl md:text-5xl lg:text-[3.45rem] leading-[1.06] text-foreground">
            {heading}
          </h2>
          <p className="mt-6 text-muted-foreground text-base md:text-lg leading-[1.8] max-w-2xl mx-auto">
            {body}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-10 md:mt-14 md:grid-cols-3 md:gap-8 lg:gap-12">
          {pillars.map((pillar) => (
            <article key={pillar.title} className="pt-6 border-t border-accent/55">
              <p className="font-headline text-[2.6rem] md:text-[2.9rem] leading-none text-accent/92 mb-4">
                {pillar.index}
              </p>
              <h3 className="font-headline text-[2rem] md:text-[2.15rem] leading-tight text-foreground mb-3">
                {pillar.title}
              </h3>
              <p className="text-muted-foreground text-sm md:text-base leading-[1.8] max-w-[30rem]">
                {pillar.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
